import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";

const Proofs = () => {
  const [certifications, setCertifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch certifications from API
  useEffect(() => {
    const fetchCertifications = async () => {
      try {
        const response = await axios.get("https://api.irfanelectricals.com/api/certificates");
        setCertifications(response.data.certificates);
      } catch (error) {
        console.error("Error fetching certifications:", error);
        setError("Failed to load certifications.");
      } finally {
        setLoading(false);
      }
    };

    fetchCertifications();
  }, []);

  return (
    <>
      <Navbar />
      <div className="container mt-5">
        <h2 className="text-center fw-bold text-primary mb-4">🏆 Our Certifications</h2>

        {/* Show loading state */}
        {loading && <p className="text-center">Loading certifications...</p>}

        {/* Show error message if API fails */}
        {error && <p className="text-danger text-center">{error}</p>}

        {/* Display Certifications */}
        <div className="row">
          {certifications.length > 0 ? (
            certifications.map((cert) => (
              <div key={cert.id} className="col-md-6 col-lg-4 mb-4">
                <div className="card shadow-lg border-0">
                  <img
                    src={`https://api.irfanelectricals.com/uploads/${cert.image}`}
                    alt={cert.name}
                    className="card-img-top rounded"
                    style={{ height: "250px", objectFit: "cover" }}
                    onError={(e) => (e.target.src = "https://via.placeholder.com/300x200?text=No+Image")}
                  />
                  <div className="card-body text-center">
                    <h5 className="card-title fw-bold">{cert.name}</h5>
                  </div>
                </div>
              </div>
            ))
          ) : (
            !loading && <p className="text-center">No certifications available.</p>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Proofs;
